// Auto Generated by gen_criterion_to_candidate_to_weight.py
export const CRITERION_TO_CANDIDATE_TO_WEIGHT = {
  Against20A: {
    AD: {
      weight: 0,
      refs: "Not an MP [https://en.wikipedia.org/wiki/Akmeemana_Dayarathana_Thero]",
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: "Voted Against [https://www.newswire.lk/2020/10/22/2nd-reading-of-20th-amendmet-passe/]",
    },
    AL: {
      weight: 0,
      refs: "Not MP at the time",
    },
    AZ: {
      weight: 0,
      refs: "Not MP at the time",
    },
    BS: {
      weight: 0,
      refs: "Not MP at the time",
    },
    DJ: {
      weight: 0,
      refs: "Not an MP [https://en.wikipedia.org/wiki/Dilith_Jayaweera]",
    },
    JR: {
      weight: 0,
      refs: "Not MP at the time",
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 0,
      refs: "Not MP at the time",
    },
    NB: {
      weight: 0,
      refs: "Not MP at the time",
    },
    NR: {
      weight: -100,
      refs: "Voted in Favour [https://www.newswire.lk/2020/10/22/2nd-reading-of-20th-amendmet-passe/]",
    },
    OH: {
      weight: 0,
      refs: "Not MP at the time",
    },
    PB: {
      weight: 0,
      refs: "Not MP at the time",
    },
    RW: {
      weight: 0,
      refs: "Not MP at the time. The amendment was passed on 22 October 2020, while Wickremesinghe was sworn in as the national list member of parliament of the UNP on 23 June 2021. [https://en.wikipedia.org/wiki/Twentieth_Amendment_to_the_Constitution_of_Sri_Lanka, https://en.wikipedia.org/wiki/Ranil_Wickremesinghe]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: "Voted Against [https://www.newswire.lk/2020/10/22/2nd-reading-of-20th-amendmet-passe/]",
    },
    SJ: {
      weight: 0,
      refs: "Not MP at the time",
    },
    SK: {
      weight: 0,
      refs: "Not MP at the time",
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "Voted Against [https://www.newswire.lk/2020/10/22/2nd-reading-of-20th-amendmet-passe/]",
    },
    WR: {
      weight: -100,
      refs: "Voted in Favour [https://www.newswire.lk/2020/10/22/2nd-reading-of-20th-amendmet-passe/]",
    },
  },
  Assets: {
    AD: {
      weight: -100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: -100,
      refs: null,
    },
    AL: {
      weight: -100,
      refs: null,
    },
    AZ: {
      weight: -100,
      refs: null,
    },
    BS: {
      weight: -100,
      refs: null,
    },
    DJ: {
      weight: -100,
      refs: null,
    },
    JR: {
      weight: -100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: -100,
      refs: null,
    },
    NB: {
      weight: -100,
      refs: null,
    },
    NR: {
      weight: -100,
      refs: null,
    },
    OH: {
      weight: -100,
      refs: null,
    },
    PB: {
      weight: -100,
      refs: null,
    },
    RW: {
      weight: -100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: null,
    },
    SJ: {
      weight: -100,
      refs: null,
    },
    SK: {
      weight: -100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: -100,
      refs: null,
    },
    WR: {
      weight: -100,
      refs: null,
    },
  },
  Attendance: {
    AD: {
      weight: 0,
      refs: "Not an MP [https://en.wikipedia.org/wiki/Akmeemana_Dayarathana_Thero]",
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: -100,
      refs: "221/383 [https://www.parliament.lk/component/members/viewMember/112]",
    },
    AL: {
      weight: 0,
      refs: "Not Currently MP",
    },
    AZ: {
      weight: 0,
      refs: "Not Currently MP",
    },
    BS: {
      weight: 0,
      refs: "Not Currently MP",
    },
    DJ: {
      weight: 0,
      refs: "Not an MP [https://en.wikipedia.org/wiki/Dilith_Jayaweera]",
    },
    JR: {
      weight: 0,
      refs: "Not Currently MP",
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 0,
      refs: "Not Currently MP",
    },
    NB: {
      weight: 0,
      refs: "Not Currently MP",
    },
    NR: {
      weight: -100,
      refs: "205/383 [https://www.parliament.lk/component/members/viewMember/1521]",
    },
    OH: {
      weight: 0,
      refs: "Not Currently MP",
    },
    PB: {
      weight: 0,
      refs: "Not Currently MP",
    },
    RW: {
      weight: 100,
      refs: "76/98 [https://www.parliament.lk/en/members-of-parliament/directory-of-members/viewMember/1244]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: "203/383 [https://www.parliament.lk/members-of-parliament/directory-of-members/viewMember/3135]",
    },
    SJ: {
      weight: 0,
      refs: "Not Currently MP",
    },
    SK: {
      weight: 0,
      refs: "Not Currently MP",
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "339/383 [https://www.parliament.lk/en/component/members/viewMember/140]",
    },
    WR: {
      weight: -100,
      refs: "198/383 [https://www.parliament.lk/component/members/viewMember/1521]",
    },
  },
  Corruption: {
    AD: {
      weight: 100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: null,
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: 0,
      refs: null,
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: -100,
      refs: "Has faced allegations and controversies, though not necessarily formal corruption charges.  [https://en.wikipedia.org/wiki/Namal_Rajapaksa]",
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: -100,
      refs: "Has faced various allegations and criticisms regarding corruption and mismanagement during his political career. [E.g. https://www.theguardian.com/world/2022/jul/18/ranil-wickremesinghe-wily-fox-who-became-sri-lanka-pm-six-times-profile/]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: null,
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: -100,
      refs: "Leader of the opposition, has faced allegations and scrutiny, although not all allegations have led to formal charges. [https://en.wikipedia.org/wiki/Sajith_Premadasa]",
    },
    WR: {
      weight: -100,
      refs: "Has faced allegations and controversies, though not necessarily formal corruption charges.  [https://en.wikipedia.org/wiki/Wijeyadasa_Rajapakshe]",
    },
  },
  Criminal: {
    AD: {
      weight: 100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: null,
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: -100,
      refs: null,
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: 100,
      refs: null,
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: null,
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: null,
    },
    WR: {
      weight: 100,
      refs: null,
    },
  },
  Economic: {
    AD: {
      weight: -100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: -100,
      refs: null,
    },
    AL: {
      weight: -100,
      refs: null,
    },
    AZ: {
      weight: -100,
      refs: null,
    },
    BS: {
      weight: -100,
      refs: null,
    },
    DJ: {
      weight: -100,
      refs: null,
    },
    JR: {
      weight: -100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: -100,
      refs: null,
    },
    NB: {
      weight: -100,
      refs: null,
    },
    NR: {
      weight: -100,
      refs: null,
    },
    OH: {
      weight: -100,
      refs: null,
    },
    PB: {
      weight: -100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: "Served as Minister of Finance on numerous occasions [https://en.wikipedia.org/wiki/Ranil_Wickremesinghe]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: null,
    },
    SJ: {
      weight: -100,
      refs: null,
    },
    SK: {
      weight: -100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: -100,
      refs: null,
    },
    WR: {
      weight: -100,
      refs: null,
    },
  },
  Education: {
    AD: {
      weight: 100,
      refs: "Bachelor of Arts, University of Peradeniya [https://en.wikipedia.org/wiki/Akmeemana_Dayarathana_Thero]",
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: "Holds a BSc in Physical Sciences from the University of Kelaniya [https://en.wikipedia.org/wiki/Anura_Kumara_Dissanayake]",
    },
    AL: {
      weight: 0,
      refs: null,
    },
    AZ: {
      weight: 0,
      refs: null,
    },
    BS: {
      weight: 0,
      refs: null,
    },
    DJ: {
      weight: 100,
      refs: "Attorney-at-Law [https://en.wikipedia.org/wiki/Dilith_Jayaweera]",
    },
    JR: {
      weight: 100,
      refs: "Holds a Degree in Management from Sri Jayawardenapura University, and a Masters in Business from Colombo University [https://en.wikipedia.org/wiki/Janaka_Ratnayake]",
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 0,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: "Attorney at Law [https://www.dailymirror.lk/breaking-news/Nuwan-Bopage-named-Presidential-candidate-of-Aragalaya-activists/108-288277]",
    },
    NR: {
      weight: 100,
      refs: "Attorney at Law [https://en.wikipedia.org/wiki/Namal_Rajapaksa]",
    },
    OH: {
      weight: 0,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: "Has a PhD in Physics from CTH Sweden [https://sci.pdn.ac.lk/physics/staff/PWSK-Bandaranayake]",
    },
    RW: {
      weight: 100,
      refs: "Attorney at Law [https://en.wikipedia.org/wiki/Ranil_Wickremesinghe]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: null,
    },
    SJ: {
      weight: 0,
      refs: null,
    },
    SK: {
      weight: 0,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "Holds a degree from the London School of Economics. [https://en.wikipedia.org/wiki/Sajith_Premadasa]",
    },
    WR: {
      weight: 100,
      refs: "Attorney at Law [https://en.wikipedia.org/wiki/Wijeyadasa_Rajapakshe]",
    },
  },
  Insurrections: {
    AD: {
      weight: 100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: -100,
      refs: "Having been involved in the JVP from his school days, Dissanayake joined the JVP in 1987, becoming active in student politics, engaged in full time political activities from 1987, with the onset of the 1987\u20131989 JVP insurrection. [https://en.wikipedia.org/wiki/Anura_Kumara_Dissanayake]",
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: 100,
      refs: null,
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: 100,
      refs: null,
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: null,
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: null,
    },
    WR: {
      weight: 100,
      refs: null,
    },
  },
  Leader: {
    AD: {
      weight: -100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: "Leader of the JVP [https://en.wikipedia.org/wiki/Janatha_Vimukthi_Peramuna#Leader]",
    },
    AL: {
      weight: -100,
      refs: null,
    },
    AZ: {
      weight: -100,
      refs: null,
    },
    BS: {
      weight: -100,
      refs: null,
    },
    DJ: {
      weight: -100,
      refs: null,
    },
    JR: {
      weight: -100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: -100,
      refs: null,
    },
    NB: {
      weight: -100,
      refs: null,
    },
    NR: {
      weight: -100,
      refs: null,
    },
    OH: {
      weight: -100,
      refs: null,
    },
    PB: {
      weight: -100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: "Leader of the UNP [https://en.wikipedia.org/wiki/United_National_Party]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: null,
    },
    SJ: {
      weight: -100,
      refs: null,
    },
    SK: {
      weight: -100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "Leader of the SJB [https://en.wikipedia.org/wiki/Samagi_Jana_Balawegaya]",
    },
    WR: {
      weight: -100,
      refs: null,
    },
  },
  Military: {
    AD: {
      weight: 100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: null,
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: 100,
      refs: null,
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: 100,
      refs: null,
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: "He was the eighteenth Commander of the Sri Lankan Army, and under his command the Sri Lankan Army ended the 26-year Sri Lankan Civil War in 2009. [https://en.wikipedia.org/wiki/Sarath_Fonseka]",
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: null,
    },
    WR: {
      weight: 100,
      refs: null,
    },
  },
  Minister: {
    AD: {
      weight: -100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: "Minister of Agriculture, Livestock, Lands, and Irrigation (2004-2005) [https://en.wikipedia.org/wiki/Anura_Kumara_Dissanayake]",
    },
    AL: {
      weight: -100,
      refs: null,
    },
    AZ: {
      weight: -100,
      refs: null,
    },
    BS: {
      weight: -100,
      refs: null,
    },
    DJ: {
      weight: -100,
      refs: null,
    },
    JR: {
      weight: -100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: -100,
      refs: null,
    },
    NB: {
      weight: -100,
      refs: null,
    },
    NR: {
      weight: 100,
      refs: "Multiple ministerial positions [https://en.wikipedia.org/wiki/Namal_Rajapaksa]",
    },
    OH: {
      weight: -100,
      refs: null,
    },
    PB: {
      weight: -100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: "Multiple ministerial positions, including Prime Minister and various other cabinet roles [https://en.wikipedia.org/wiki/Ranil_Wickremesinghe]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: "Minister of Wildlife and Sustainable Development, Minister of Regional Development [https://en.wikipedia.org/wiki/Sarath_Fonseka]",
    },
    SJ: {
      weight: -100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: "Deputy Minister of Agriculture (2000-2001) [https://en.wikipedia.org/wiki/11th_Parliament_of_Sri_Lanka]",
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "Minister of Housing, Construction and Cultural Affairs, Deputy Minister of Health [https://en.wikipedia.org/wiki/Sajith_Premadasa]",
    },
    WR: {
      weight: 100,
      refs: "Multiple ministerial positions [https://en.wikipedia.org/wiki/Wijeyadasa_Rajapakshe]",
    },
  },
  Moderate: {
    AD: {
      weight: -100,
      refs: "Member of the JHU and the Sinhala Rawaya [https://en.wikipedia.org/wiki/Akmeemana_Dayarathana_Thero]",
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: -100,
      refs: "Anura Kumara Dissanayake, the Leader of the Janatha Vimukthi Peramuna (JVP) and the National People's Power (NPP) in Sri Lanka, has a background associated with leftist ideologies, including Marxism-Leninism. [https://en.wikipedia.org/wiki/Janatha_Vimukthi_Peramuna]",
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: 0,
      refs: null,
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: 100,
      refs: null,
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: null,
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: null,
    },
    WR: {
      weight: 100,
      refs: null,
    },
  },
  ParaMilitary: {
    AD: {
      weight: 100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: -100,
      refs: "He was involved in the 1987-1989 JVP insurrection, which had a paramilitary aspect [https://en.wikipedia.org/wiki/1987%E2%80%931989_JVP_insurrection]",
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: 100,
      refs: null,
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: 100,
      refs: null,
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: null,
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: null,
    },
    WR: {
      weight: 100,
      refs: null,
    },
  },
  Presidency: {
    AD: {
      weight: 0,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: "He strongly advocates for the abolishment of the executive presidency, considering it essential for the country's political and economic revival. He has promised to introduce a new constitution that includes this change if his party comes to power [https://asianmirror.lk/news/item/34833-abolishment-of-executive-presidency-needed-for-economic-revival-in-sl-akd]",
    },
    AL: {
      weight: 0,
      refs: null,
    },
    AZ: {
      weight: 0,
      refs: null,
    },
    BS: {
      weight: 0,
      refs: null,
    },
    DJ: {
      weight: 0,
      refs: null,
    },
    JR: {
      weight: 0,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 0,
      refs: null,
    },
    NB: {
      weight: 0,
      refs: null,
    },
    NR: {
      weight: -100,
      refs: null,
    },
    OH: {
      weight: 0,
      refs: null,
    },
    PB: {
      weight: 0,
      refs: null,
    },
    RW: {
      weight: -100,
      refs: "Ranil Wickramasinghe has shown fluctuating positions on this issue. While he has supported the idea of abolishing the executive presidency in the past, his actions as president have been seen as consolidating power within the executive branch ",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: "Sarath Fonseka has been critical of the executive presidency and has indicated support for its abolition, preferring a system with more distributed power [https://www.newindianexpress.com/world/2009/Nov/30/fonseka-vows-to-end-executive-presidency-108543.html]",
    },
    SJ: {
      weight: 0,
      refs: null,
    },
    SK: {
      weight: 0,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "Sajith Premadasa has advocated for the abolishment of the executive presidency, emphasizing the need for constitutional reforms to ensure a more balanced distribution of power [https://www.dailymirror.lk/breaking-news/Executive-Presidency-should-be-changed-even-if-Sajith-wins-Eran/108-287450]",
    },
    WR: {
      weight: 100,
      refs: null,
    },
  },
  RajapaksaCabinet: {
    AD: {
      weight: 100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: null,
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: -100,
      refs: null,
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: -100,
      refs: "He has held multiple ministerial positions under both presidents Mahinda and Gotabaya Rajapaksa [https://en.wikipedia.org/wiki/Namal_Rajapaksa]",
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: -100,
      refs: "He was appointed as Prime Minister and Minister of Finance, Economic Stability and National Policies by Gotabaya Rajapaksa in May 2022. [https://en.wikipedia.org/wiki/Ranil_Wickremesinghe]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: null,
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: null,
    },
    WR: {
      weight: -100,
      refs: "He has held multiple ministerial positions under both presidents Mahinda and Gotabaya Rajapaksa [https://en.wikipedia.org/wiki/Wijeyadasa_Rajapakshe]",
    },
  },
  Seat: {
    AD: {
      weight: -100,
      refs: null,
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: "Colombo District [https://en.wikipedia.org/wiki/16th_Parliament_of_Sri_Lanka]",
    },
    AL: {
      weight: -100,
      refs: null,
    },
    AZ: {
      weight: -100,
      refs: null,
    },
    BS: {
      weight: -100,
      refs: null,
    },
    DJ: {
      weight: -100,
      refs: null,
    },
    JR: {
      weight: -100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: -100,
      refs: null,
    },
    NB: {
      weight: -100,
      refs: null,
    },
    NR: {
      weight: 100,
      refs: "Hambantota District [https://en.wikipedia.org/wiki/16th_Parliament_of_Sri_Lanka]",
    },
    OH: {
      weight: -100,
      refs: null,
    },
    PB: {
      weight: -100,
      refs: null,
    },
    RW: {
      weight: -100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: null,
    },
    SJ: {
      weight: -100,
      refs: null,
    },
    SK: {
      weight: -100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "Colombo District [https://en.wikipedia.org/wiki/16th_Parliament_of_Sri_Lanka]",
    },
    WR: {
      weight: 100,
      refs: "Colombo District [https://en.wikipedia.org/wiki/16th_Parliament_of_Sri_Lanka]",
    },
  },
  SLPP: {
    AD: {
      weight: -100,
      refs: "Affiliated [https://en.wikipedia.org/wiki/Akmeemana_Dayarathana_Thero]",
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: null,
    },
    AL: {
      weight: 100,
      refs: null,
    },
    AZ: {
      weight: 100,
      refs: null,
    },
    BS: {
      weight: 100,
      refs: null,
    },
    DJ: {
      weight: 100,
      refs: "Important supporter of Gotabaya Rajapakse's 2019 Election Campaign [https://en.wikipedia.org/wiki/Dilith_Jayaweera]",
    },
    JR: {
      weight: 100,
      refs: null,
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 100,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: null,
    },
    NR: {
      weight: -100,
      refs: "He was elected to parliament in 2020 as a member of the SLPP [https://en.wikipedia.org/wiki/16th_Parliament_of_Sri_Lanka]",
    },
    OH: {
      weight: 100,
      refs: null,
    },
    PB: {
      weight: 100,
      refs: null,
    },
    RW: {
      weight: 100,
      refs: null,
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: 100,
      refs: null,
    },
    SJ: {
      weight: 100,
      refs: null,
    },
    SK: {
      weight: 100,
      refs: null,
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: null,
    },
    WR: {
      weight: -100,
      refs: "He was elected to parliament in 2020 as a member of the SLPP, but has since moved to the SLFP [https://en.wikipedia.org/wiki/16th_Parliament_of_Sri_Lanka]",
    },
  },
  Under65: {
    AD: {
      weight: 100,
      refs: "Born in 1970 [https://en.wikipedia.org/wiki/Akmeemana_Dayarathana_Thero]",
    },
    AK: {
      weight: 0,
      refs: null,
    },
    AKD: {
      weight: 100,
      refs: "Born 1968 [https://en.wikipedia.org/wiki/Anura_Kumara_Dissanayake]",
    },
    AL: {
      weight: 0,
      refs: null,
    },
    AZ: {
      weight: 0,
      refs: null,
    },
    BS: {
      weight: 0,
      refs: null,
    },
    DJ: {
      weight: 100,
      refs: "Born in 1967 [https://en.wikipedia.org/wiki/Dilith_Jayaweera]",
    },
    JR: {
      weight: 100,
      refs: "Born 1964 [https://en.wikipedia.org/wiki/Janaka_Ratnayake]",
    },
    KK: {
      weight: 0,
      refs: null,
    },
    KP: {
      weight: 0,
      refs: null,
    },
    NB: {
      weight: 100,
      refs: "No data on birth date. Assuming under 65 based on appearance [https://www.dailymirror.lk/breaking-news/Nuwan-Bopage-named-Presidential-candidate-of-Aragalaya-activists/108-288277]",
    },
    NR: {
      weight: -100,
      refs: "Born 1986 [https://en.wikipedia.org/wiki/Namal_Rajapaksa]",
    },
    OH: {
      weight: 0,
      refs: null,
    },
    PB: {
      weight: 0,
      refs: null,
    },
    RW: {
      weight: -100,
      refs: "Born 1946 [https://en.wikipedia.org/wiki/Ranil_Wickremesinghe]",
    },
    SA: {
      weight: 0,
      refs: null,
    },
    SF: {
      weight: -100,
      refs: "Born 1950 [https://en.wikipedia.org/wiki/Sarath_Fonseka]",
    },
    SJ: {
      weight: 0,
      refs: null,
    },
    SK: {
      weight: -100,
      refs: "Born 1951 [https://www.parliament.lk/members-of-parliament/directory-of-members/viewMember/3038]",
    },
    SM: {
      weight: 0,
      refs: null,
    },
    SP: {
      weight: 100,
      refs: "Born 1967 [https://en.wikipedia.org/wiki/Sajith_Premadasa]",
    },
    WR: {
      weight: -100,
      refs: "Born 1959 [https://en.wikipedia.org/wiki/Wijeyadasa_Rajapakshe]",
    },
  },
};
